.qumra-checkout-button{
    width: 100%;
}